<script>
export default {
  name: "dropdown",
  props: {
    dataSourceController: String,
    dataSourceMethod: String,
    dataSource: Array,
    inputValue: String,
    placeHolderText: String,
    parameters: Object,
    label: String,
    disabled: Boolean,
  },
  data: function() {
    return {
      data: [],
    };
  },
  methods: {
    async getDataSource() {
      this.data = await this.$store.dispatch("getRequest", { controller: this.dataSourceController, method: this.dataSourceMethod, parameters: this.parameters });
    },
    updateValue: function(value) {
      this.$emit("input", value);
    },
  },
  async mounted() {
    var self = this;
    if (self.dataSourceController && self.dataSourceMethod) {
      await self.getDataSource();
    } else {
      self.data = self.dataSource;
    }
  },
};
</script>
<template>
  <div style="margin-bottom:0.5rem;">
    <label v-if="label">{{ label }}</label
    ><br v-if="label" />
    <select :disabled="disabled" v-if="data.length" :value="inputValue" v-on:click.stop="updateValue($event.target.value)" class="btn btn-light">
      <option value="" selected>{{ placeHolderText ? placeHolderText : "--Please Select--" }}</option>
      <option v-for="(item, index) in data" :key="`dropdown-${index}`" :value="item.Key">{{ item.Value }}</option>
    </select>
  </div>
</template>
<style scoped>
select {
  width: 100%;
}
</style>
